_ = require('lodash')
$ = require('jquery')
moment = require('moment')

IndexCtrl = ($scope, $routeParams, $filter, $translate, ProfileService, userInfo) ->
  $scope.user = undefined
  $scope.isOwner = $routeParams.owner? && $routeParams.owner == 'true'

  ProfileService.getSettingAccount($routeParams.user_id, $translate.preferredLanguage()).then (resp) ->
    $scope.user = resp.data
    $scope.user.public_club_setting = false

  from = if $routeParams.from? then $routeParams.from else moment().startOf('year').format('YYYY-MM-DD')
  to = if $routeParams.to? then $routeParams.to else moment().endOf('year').format('YYYY-MM-DD')
  round_type = "1,0.5,1.5"

  ProfileService.getScoreCardsAnalysis($routeParams.user_id, from, to, round_type).then (resp) ->
    $scope.analysisData = resp.data

  ProfileService.getPhotoScoreCards($routeParams.user_id).then (resp) ->
    $scope.photo_score_cards = resp.data.photo_score_cards

  ProfileService.getFrequentlyCourses($routeParams.user_id).then (resp) ->
    $scope.courses = resp.data.courses

  ProfileService.getLatestRounds($routeParams.user_id).then (resp) ->
    $scope.score_cards = resp.data.score_cards

  $scope.$watch($scope.analysisData , () ->
    setTimeout(() ->
      $(document).ready ->
        heights = $('.score-section .score-item .score-label').map(->
          $(this).height()
        ).get()
        maxHeight = Math.max.apply(null, heights)
        $('.score-section .score-item .score-label').height maxHeight
    , 3000)
  ,true)

  $scope.displayUserName = ->
    firstName = $scope.user?.first_name ? ''
    lastName = $scope.user?.last_name ? ''
    if firstName + lastName == ''
      return $filter('translate')('_RANKING_GROUP.EVENT_RANK.UNNAMED')

    if /^ja/i.test $translate.preferredLanguage()
      return lastName + " " + firstName
    return firstName + " " + lastName

  $scope.formatLongDate = (date) ->
    if /^ja/i.test $translate.preferredLanguage()
      moment(date).format("YYYY年MM月DD日")
    else
      moment(date).format(moment.localeData().longDateFormat('LL'))

  $scope.getPageTitle = ->
    if $scope.isOwner
      $filter('translate')('_PROFILE.TITLE_PREVIEW')

  $scope.getTextOfAvatarProfile = ->
    $(document).ready ->
      $avatarElement = $(".user-section .avatar-for-#{$scope.user.user_id} .avatar-image-text")
      if $scope.user.display_text_avatar.length == 1
        $avatarElement.removeClass('two-characters')
        $avatarElement.addClass('one-character')
      else
        $avatarElement.removeClass('one-character')
        $avatarElement.addClass('two-characters')
    $scope.user.display_text_avatar

  $scope.isAvatarProfileColor = ->
    $scope.user?.avatar_image_path?.indexOf('avatar_color') > -1

IndexCtrl.$inject = [
  '$scope'
  '$routeParams'
  '$filter'
  '$translate'
  'ProfileService'
  'userInfo'
]

module.exports = IndexCtrl



// WEBPACK FOOTER //
// ./~/coffeelint-loader!./ngapp/javascript/web/profile/index-controller.coffee